module.exports = __webpack_public_path__ + "media/images/business/img-about-0814c0fc71f824dfc5e9eb0499c63c49.png";